import React, { useEffect, useRef, useState } from 'react';
import api from '../utils/api';

// Görev yorumları. "@" yazınca kişi önerileri çıkar; seçilen kişi "@Ad Soyad" olarak eklenir.
export default function TaskComments({ taskId, users, onCountChange }) {
  const [items, setItems] = useState([]);
  const [text, setText] = useState('');
  const [saving, setSaving] = useState(false);
  const [suggest, setSuggest] = useState(null); // { query, start }
  const ref = useRef(null);

  useEffect(() => {
    api.get(`/tasks/${taskId}/comments`).then(r => setItems(r.data)).catch(() => {});
  }, [taskId]);

  const onChange = (e) => {
    const v = e.target.value; setText(v);
    const pos = e.target.selectionStart;
    const m = v.slice(0, pos).match(/@([\p{L}]*)$/u);
    setSuggest(m ? { query: m[1].toLocaleLowerCase('tr'), start: pos - m[0].length, end: pos } : null);
  };
  const pick = (u) => {
    const v = text.slice(0, suggest.start) + `@${u.name} ` + text.slice(suggest.end);
    setText(v); setSuggest(null);
    setTimeout(() => ref.current && ref.current.focus(), 0);
  };
  const matches = suggest ? users.filter(u => u.name.toLocaleLowerCase('tr').includes(suggest.query)).slice(0, 6) : [];

  const send = async () => {
    if (!text.trim()) return;
    setSaving(true);
    try {
      const r = await api.post(`/tasks/${taskId}/comments`, { body: text.trim() });
      const next = [...items, r.data];
      setItems(next); setText('');
      if (onCountChange) onCountChange(next.length);
    } catch (e) { /* hata api katmanında gösterilir */ }
    setSaving(false);
  };

  const fmt = (d) => new Date(d).toLocaleString('tr-TR', { day: 'numeric', month: 'short', hour: '2-digit', minute: '2-digit' });
  // Bahsedilen kişileri vurgula: önce tam ad, sonra (tekse) ilk ad
  const esc = (x) => x.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
  const names = users.flatMap(u => {
    const first = u.name.split(' ')[0];
    const unique = users.filter(x => x.name.split(' ')[0] === first).length === 1;
    return unique && first !== u.name ? [u.name, first] : [u.name];
  }).sort((a, b) => b.length - a.length);
  const mentionRe = names.length ? new RegExp(`(@(?:${names.map(esc).join('|')}))(?![\\p{L}])`, 'gu') : null;
  const render = (body) => (mentionRe ? String(body).split(mentionRe) : [String(body)])
    .map((p, i) => (i % 2 ? <strong key={i} style={{ color: 'var(--accent)' }}>{p}</strong> : p));

  return (
    <div className="tc">
      <div className="form-label" style={{ marginBottom: 8 }}>Yorumlar {items.length > 0 && `(${items.length})`}</div>
      {items.length === 0 && <div className="text-muted text-sm" style={{ marginBottom: 8 }}>Henüz yorum yok.</div>}
      {items.map(c => (
        <div key={c.id} className="tc__item">
          <div className="tc__head"><strong>{c.user_name || '—'}</strong><span>{fmt(c.created_at)}</span></div>
          <div className="tc__body">{render(c.body)}</div>
        </div>
      ))}
      <div style={{ position: 'relative' }}>
        <textarea ref={ref} className="form-input" rows={2} value={text} onChange={onChange}
          placeholder="Yorum yaz… (@ ile birinden bahset)" style={{ resize: 'vertical' }}
          onKeyDown={(e) => { if (e.key === 'Enter' && (e.metaKey || e.ctrlKey)) send(); }} />
        {matches.length > 0 && (
          <div className="tc__suggest">
            {matches.map(u => <button type="button" key={u.id} onMouseDown={(e) => { e.preventDefault(); pick(u); }}>{u.name}</button>)}
          </div>
        )}
      </div>
      <div style={{ display: 'flex', justifyContent: 'flex-end', marginTop: 6 }}>
        <button type="button" className="btn btn--secondary" onClick={send} disabled={saving || !text.trim()}>{saving ? 'Gönderiliyor…' : 'Yorum ekle'}</button>
      </div>
    </div>
  );
}
